var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button",class:_vm.activity || _vm.disabled ? 'disabled' : undefined,on:{"click":_vm.click}},[(_vm.activity)?_c('SimpleSpinner',{staticClass:"icon"}):_vm._e(),_c('div',{staticClass:"placeholder"}),_c('span',{staticClass:"text"},[_vm._t("default")],2),_c('div',{staticClass:"placeholder"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }